module.exports = __webpack_public_path__ + "img/img04.ba3408f1.png";